import { useUser } from '@faro/auth';
import { SystemConfig } from '@faro/study-designer-model';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { cacheForeverQueryOptions } from '../package/react-query';
import { useServiceContext } from '../service';

export function useSystemConfigQuery(): UseQueryResult<SystemConfig> {
    const { systemConfigService } = useServiceContext();
    const user = useUser();

    return useQuery({
        ...cacheForeverQueryOptions,
        queryKey: ['systemConfig'],
        queryFn: () => systemConfigService.get(),
        enabled: !isEmpty(user?.roles),
    });
}
